import { useState } from 'react';
import { useAnalytics } from 'hooks/useAnalytics';
import { InputExtraLarge, SecondaryButtonExtraLarge } from 'elements/Forms';

const BlogSubscription = () => {
  const { identify, track } = useAnalytics();
  const [subscribed, setSubscribed] = useState(false);

  const blogSubscribe = async (event) => {
    event.preventDefault();

    let email = event.target.email.value;
    email = email.trim().toLowerCase();

    setSubscribed(true);

    await identify(email);
    await track('Subscribed to the Blog', {
      email,
    });
  };

  return (
    <div className="mx-auto mt-12 max-w-lg rounded-lg bg-blue-06 p-6 text-center shadow-md lg:max-w-none">
      {!subscribed ? (
        <form
          onSubmit={blogSubscribe}
          className="flex flex-row justify-center gap-x-4"
        >
          <label htmlFor="emailAddress" className="w-full max-w-sm">
            <span className="sr-only">Email</span>
            <InputExtraLarge
              type="email"
              autoComplete="email"
              name="email"
              id="email"
              placeholder="Enter your email"
              required
            />
          </label>
          <SecondaryButtonExtraLarge className="w-full sm:w-auto sm:flex-shrink-0">
            Subscribe Now
          </SecondaryButtonExtraLarge>
        </form>
      ) : (
        <p className="mt-3 text-lg text-white">Thanks for subscribing…</p>
      )}
    </div>
  );
};

export default BlogSubscription;
